import React from 'react';
import SuperAdminLayout from '../../components/admin/SuperAdminLayout';
import RevenueAnalytics from '../../components/admin/RevenueAnalytics';

const RevenuePage: React.FC = () => {
  return (
    <SuperAdminLayout>
      <RevenueAnalytics />
    </SuperAdminLayout>
  );
};

export default RevenuePage;